import { Head, Link, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Company {
  id: number
  name: string
  nickname: string
  status: number
  color1: string | null
  color2: string | null
  manager_name: string | null
}

interface Props {
  companies: Company[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Manage", href: "/admin/companies" },
  { title: "Companies", href: "/admin/companies" },
]

export default function Index({ companies }: Props) {
  const handleDelete = (id: number) => {
    if (confirm("Are you sure you want to delete this company?")) {
      router.delete(`/admin/companies/${id}`)
    }
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Companies" />

      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Companies</h1>
          <Link
            href="/admin/companies/new"
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Company
          </Link>
        </div>

        {companies.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Company
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Nickname
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Manager
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Status
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {companies.map((c) => (
                <tr
                  key={c.id}
                  className={`hover:bg-hpi-pale-blue ${c.status !== 0 ? "opacity-50" : ""}`}
                >
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <div className="flex items-center gap-2">
                      {c.color1 && c.color2 && (
                        <span
                          className="inline-block h-4 w-4 rounded-full border"
                          style={{
                            backgroundColor: c.color1,
                            borderColor: c.color2,
                          }}
                        />
                      )}
                      <Link
                        href={`/admin/companies/${c.id}`}
                        className="text-hpi-active-blue hover:underline"
                      >
                        {c.name}
                      </Link>
                    </div>
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {c.nickname}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {c.manager_name}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {c.status === 0 ? "Active" : "Inactive"}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/admin/companies/${c.id}/edit`}
                      className="text-hpi-active-blue mr-2 hover:underline"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(c.id)}
                      className="text-hpi-red hover:underline"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No companies found.</p>
        )}
      </div>
    </AppLayout>
  )
}
